import { useCallback, useState } from 'react';
import { connectorSourceService } from '../services';
import { ConnectorSource } from '../types/entities';

interface UseConnectorSourcesOptions {
  activeOnly?: boolean;
}

export const useConnectorSources = (
  organizationId?: number,
  options: UseConnectorSourcesOptions = {}
) => {
  const { activeOnly = true } = options;
  const [connectorSources, setConnectorSources] = useState<ConnectorSource[]>([]);
  const [isLoadingConnectors, setIsLoadingConnectors] = useState(false);

  const loadConnectorSources = useCallback(async () => {
    if (!organizationId) return;
    setIsLoadingConnectors(true);
    try {
      const response = await connectorSourceService.list({
        page: 1,
        page_size: 100,
        ...(activeOnly ? { is_active: true } : {}),
      });
      setConnectorSources(response.items || []);
    } catch {
      setConnectorSources([]);
    } finally {
      setIsLoadingConnectors(false);
    }
  }, [organizationId, activeOnly]);

  const toggleConnectorSource = useCallback(
    (
      source: ConnectorSource,
      selectedSources: ConnectorSource[],
      onUpdate: (sources: ConnectorSource[]) => void
    ) => {
      const isSelected = selectedSources.some(item => item.id === source.id);
      if (isSelected) {
        onUpdate(selectedSources.filter(item => item.id !== source.id));
      } else {
        onUpdate([...selectedSources, source]);
      }
    },
    []
  );

  return {
    connectorSources,
    isLoadingConnectors,
    loadConnectorSources,
    toggleConnectorSource,
  };
};
